import { createContext, useContext, useState, useCallback } from 'react';
import '../styles/Modal.css';

const ModalContext = createContext(null);

// Usage:
//   openModal({ title, text, confirm?: { label, onClick, danger? }, cancel?: { label } })
//
// - confirm omitted  → single "Ok" / dismiss button only
// - confirm present  → confirm button + cancel button
export function ModalProvider({ children }) {
  const [modal, setModal] = useState(null);

  const openModal = useCallback((options) => setModal(options), []);
  const closeModal = useCallback(() => setModal(null), []);

  async function handleConfirm() {
    if (modal?.confirm?.onClick) await modal.confirm.onClick();
    closeModal();
  }

  const hasConfirm = !!modal?.confirm;

  return (
    <ModalContext.Provider value={{ openModal, closeModal }}>
      {children}
      {modal && (
        <div className="modal-backdrop" onClick={closeModal}>
          <div className="modal-box" onClick={e => e.stopPropagation()}>
            {modal.title && <h2 className="modal-title">{modal.title}</h2>}
            {modal.text  && <p  className="modal-text">{modal.text}</p>}
            <div className="modal-actions">
              {hasConfirm ? (
                <>
                  <button
                    className={`modal-btn modal-btn--confirm${modal.confirm.danger ? ' danger' : ''}`}
                    onClick={handleConfirm}
                  >
                    {modal.confirm.label}
                  </button>
                  <button className="modal-btn modal-btn--cancel" onClick={closeModal}>
                    {modal.cancel?.label || 'Cancel'}
                  </button>
                </>
              ) : (
                <button className="modal-btn modal-btn--confirm" onClick={closeModal}>
                  {modal.cancel?.label || 'Ok'}
                </button>
              )}
            </div>
          </div>
        </div>
      )}
    </ModalContext.Provider>
  );
}

export function useModal() {
  return useContext(ModalContext);
}
